import { useRef } from 'react';
import { sample } from 'lodash';
import { generateSimilarColor } from 'common/constants/_colors';

const useColorAssigner = (defaultPalette = []) => {
  const colorsMap = useRef({});
  const palette = useRef([...defaultPalette]);
  const originPalette = useRef([...defaultPalette]);
  const assignedPaletteColors = useRef([]);

  const reset = () => {
    colorsMap.current = {};
    palette.current = [...defaultPalette];
    originPalette.current = [...defaultPalette];
    assignedPaletteColors.current = [];
  };

  const switchPalette = newPalette => {
    palette.current = newPalette;
    originPalette.current = newPalette;
    assignedPaletteColors.current = [];
  };

  const setKeyColor = (key = '', color) => {
    colorsMap.current[key.toLowerCase()] = color;
  };
  const getKeyColor = (key = '') => colorsMap.current[key.toLowerCase()];

  const isColorNotAssignedYet = color =>
    !assignedPaletteColors.current.includes(color);

  const assignColor = (key = '') => {
    if (key?.length === 0) return;

    const cachedColor = getKeyColor(key);

    let assignedColor;
    if (cachedColor && isColorNotAssignedYet(cachedColor)) {
      assignedColor = cachedColor;
    } else if (palette.current.length > 0) {
      const newColor = palette.current[0];
      if (isColorNotAssignedYet(newColor)) {
        assignedColor = newColor;
        palette.current = palette.current.slice(1);
      }
    }

    if (!assignedColor) {
      const randomColorFromPalette = sample(originPalette.current);
      assignedColor = generateSimilarColor(randomColorFromPalette, 11, 6);
    }

    assignedPaletteColors.current.push(assignedColor);
    setKeyColor(key, assignedColor);
    return assignedColor;
  };

  return {
    switchPalette,
    assignColor,
    getKeyColor,
    setKeyColor,
    reset
  };
};

export default useColorAssigner;
